import React, { useEffect, useState, useRef } from "react";
import Loader from "../Loader/Loader";
import { UpdateFeatureVoucherOrder } from "../API/Vouchers/UpdateFeatureVoucherOrder";
import { getFeaturedVoucherApi } from "../API/Vouchers/getFeaturedVoucher";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AddNew from "../../assets/Add New.svg";
import { UpdateFeaturedVouchersAPI } from "./../API/Vouchers/updateFeatureVoucher";
import swal from "sweetalert";

export const FeaturedVouchers = (props) => {
  const { loading, setLoading } = props;

  const navigate = useNavigate();
  const cityId = localStorage.getItem("cityId");

  const [items, setItems] = useState([]);
  const [isReorder, setIsReorder] = useState(false);

  useEffect(() => {
    getListing();
  }, []);

  // get-feature-voucher
  const getListing = async () => {
    setLoading(true);
    const data = {
      mms_city_id: parseInt(cityId),
    };
    try {
      const response = await getFeaturedVoucherApi(data);
      if (response.status === 429) {
        setLoading(true);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response == false) {
        setLoading(false);
        swal({
          title: `Internal server error`,
          icon: "error",
          buttons: "OK",
        });
      } else {
        const apiItems = response.data.map((item) => ({
          id: item.voucher_city_id.toString(),
          content: item,
        }));
        setItems(apiItems);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  // update-feature-reorder
  const handleUpdateFeatureList = async () => {
    setLoading(true);
    try {
      const updatedIds = items.map((item) => parseInt(item.id));
      const data = {
        mms_city_id: parseInt(cityId),
        featured_order_voucher_id: updatedIds,
      };
      const response = await UpdateFeatureVoucherOrder(data);
      if (response.success === true && response.status === 200) {
        setLoading(false);
        swal({
          title: `${response.message}`,
          icon: "success",
          buttons: "OK",
        });
        setIsReorder(false);
      } else {
        if (response.status === 429 || 400) {
          setLoading(false);
          swal({
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("Api error:", error);
    }
  };

  const ItemTypes = {
    GRID_ITEM: "GRID_ITEM",
  };

  const DraggableGridItem = ({
    id,
    content,
    index,
    moveItem,
    handleDelete,
  }) => {
    const ref = useRef(null);

    const [, drag] = useDrag({
      type: ItemTypes.GRID_ITEM,
      item: { id, index },
    });

    const [, drop] = useDrop({
      accept: ItemTypes.GRID_ITEM,
      hover: (item, monitor) => {
        const hoverBoundingRect = ref.current.getBoundingClientRect();
        const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }

        // Scroll smoothly if near the top or bottom of the grid container
        const scrollThreshold = 50; // px from the edge for triggering scroll
        const scrollSpeed = 5; // scroll speed

        if (hoverClientY < scrollThreshold) {
          window.scrollBy(0, -scrollSpeed);
        } else if (hoverClientY > hoverBoundingRect.height - scrollThreshold) {
          window.scrollBy(0, scrollSpeed);
        }
      },
    });

    drag(drop(ref));

    return (
      <div ref={ref} className="grid-square card-list">
        <button
          className="close-button"
          onClick={() =>
            handleDelete(id, content.business_id, content.voucher_name)
          }
        >
          &times;
        </button>
        <Card
          className="image-container"
          style={{ transition: "transform 0.2s ease" }}
        >
          <Card.Img variant="top" src={content.voucher_image} />
        </Card>
        <Card.Body style={{ padding: "16px 0px 0px 0px" }}>
          <Card.Title
            className="card-listing-text"
            data-fullname={content.voucher_name}
          >
            {content.voucher_name}
          </Card.Title>
        </Card.Body>
      </div>
    );
  };

  const AddNewCard = ({ handleAddNewFeature }) => {
    return (
      <div className="grid-card">
        <div
          variant="primary"
          className="add-new-btn-product btn-container"
          onClick={handleAddNewFeature}
        >
          Add New <img src={AddNew} className="add-icon" alt="Add New" />
        </div>
      </div>
    );
  };

  const moveItem = (fromIndex, toIndex) => {
    const updatedItems = [...items];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    console.log(updatedItems, "updatedItems");
    setItems(updatedItems);
    setIsReorder(true);
  };

  const handleDelete = (id, businessId, voucherName) => {
    const payload = {
      mms_city_id: parseInt(cityId),
      business_id: parseInt(businessId),
      city_voucher_id: parseInt(id),
      action_key: "disable",
    };

    swal({
      title: `Are you sure you want to remove "${voucherName}" voucher from the featured vouchers?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        setLoading(true);
        try {
          const response = await UpdateFeaturedVouchersAPI(payload);
          console.log(response.data, "response");
          if (response.status === 429) {
            setLoading(true);
            swal({
              title: `${response.message}`,
              icon: "error",
              buttons: "OK",
            });
          } else if (response === false) {
            swal({
              title: `${response.message}`,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          } else if (response.status === 400) {
            swal({
              title: `${response.message}`,
              icon: "error",
              buttons: "OK",
            }).then(() => {
              setLoading(true);
              window.location.reload();
            });
          } else {
            getListing();
            setLoading(false);
            swal({
              title: `The "${voucherName}" voucher has been successfully removed from the featured vouchers.`,
              icon: "success",
              buttons: "Ok",
            });
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching data:", error);
        }
      }
    });
  };

  const handleAddNewFeature = () => {
    navigate("/vouchers/manage-vouchers");
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="featured-main mb-2">
        <div>
          <p className="page-maintitle py-2">Featured Vouchers</p>
          <p className="page-subtitle">
            To re-arrange the order of the vouchers drag and drop in the desired
            position and click "Save" button.
          </p>
        </div>
        <div className="featured-listings">
          <div
            variant="primary"
            className={`add-new-btn-product btn-container ${
              isReorder ? "item-dragged" : "item-not-dragged"
            }`}
            onClick={isReorder ? handleUpdateFeatureList : null}
            style={{ fontSize: 17 }}
          >
            Save
          </div>
        </div>
      </div>

      <DndProvider backend={HTML5Backend}>
        <div className="card-list-container-product mt-3">
          <div className="col"></div>
          <div
            className={`${items.length === 0 ? "" : "grid-container-product"}`}
          >
            {items.map((item, index) => (
              <DraggableGridItem
                key={item.id}
                id={item.id}
                content={item.content}
                index={index}
                moveItem={moveItem}
                handleDelete={handleDelete}
              />
            ))}

            {items.length < 8 && (
              <AddNewCard handleAddNewFeature={handleAddNewFeature} />
            )}
          </div>
          <div className="col"></div>
        </div>
      </DndProvider>
    </>
  );
};
